import React, { ComponentType, createContext, FC } from 'react';

import { SegmentStatus, UserSegmentFragment } from 'api';
import { isAdminUser } from 'helpers';
import { Queries } from 'components';
import { useCurrentUser } from 'hooks';

export interface IWithSegments {
  segments: UserSegmentFragment[];
}

export const SegmentsContext = createContext<IWithSegments>({
  segments: [],
});

export const SegmentsProvider: FC = ({ children }) => {
  const currentUser = useCurrentUser();

  if (!isAdminUser(currentUser)) {
    return <SegmentsContext.Provider value={{ segments: [] }}>{children}</SegmentsContext.Provider>;
  }

  return (
    <Queries.GetUserSegments status={SegmentStatus.Active}>
      {segments => (
        <SegmentsContext.Provider value={{ segments }}>{children}</SegmentsContext.Provider>
      )}
    </Queries.GetUserSegments>
  );
};

const withSegments =
  (status = SegmentStatus.Active) =>
  <T extends Record<string, UserSegmentFragment[]>>(Component: ComponentType<T & IWithSegments>) =>
  (props: T) => {
    const currentUser = useCurrentUser();

    if (!isAdminUser(currentUser)) {
      return <Component {...props} segments={[]} />;
    }

    return (
      <Queries.GetUserSegments status={status}>
        {segments => <Component {...props} segments={segments} />}
      </Queries.GetUserSegments>
    );
  };

export default withSegments;
